import React from 'react';

import { withRouter } from 'react-router-dom';
import { CommaSeparator, onChangeCommaSeperator } from '../../AppUtil/AppUtil';

import { LoadingOutlined } from '@ant-design/icons';
import { FormControlLabel, MuiThemeProvider, TextField, createMuiTheme } from '@material-ui/core';
import { green, orange } from '@material-ui/core/colors';
import { Lock } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import { Spin } from 'antd';
import MUIDataTable from 'mui-datatables';
import Swal from 'sweetalert2';

import Loader from '../../Component/Common/Loader';
import ServiceChargeService from '../../Service/ServiceChargeService';
import Session from '../../Service/Session';
import { toastError, toastOnDeleteRecordConfirm } from '../../SweetAlertUtil/util';
import PageHeader from '../Common/PageHeader';
import { VERIFY_AUTHORIZATION } from '../Util/userType_constants';
import AddForm from './AddForm';

class ServiceCharge extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRow: null,
			_isLoading: false,
			_isLoader: false,
			tableData: [],
			total: null,
			max: null,
			price: null
		};
	}

	setServiceCharge = async () => {
		this.setState({ _isLoader: true });
		try {
			const data = await ServiceChargeService.getList();

			if (data && data.service_charge.length > 0) {
				this.setState({
					tableData: data.service_charge,
					total: data.total,
					_isLoader: false
				});
			} else {
				this.setState({ _isLoader: false });
			}
		} catch (error) {
			toastError(error.message);
			this.setState({ _isLoader: false });
		}
	};

	updateMaxPrice(value, name) {
		if (name === 'max') {
			this.setState(() => {
				this.state.max = value;
			});
		} else {
			this.setState(() => {
				this.state.price = value;
			});
		}
	}

	editClicked(id) {
		this.changeSelectedRow(id);
	}

	changeSelectedRow(id) {
		this.setState({ selectedRow: id });
	}

	cancelEdit() {
		this.removeSelectedRow();
	}

	removeSelectedRow() {
		this.setState({ selectedRow: null });
	}

	setLoader(value) {
		this.setState({ _isLoading: value });
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	deleteClicked(order_number) {
		toastOnDeleteRecordConfirm().then(async data => {
			if (data && data.value) {
				this.setLoader(true);

				ServiceChargeService.delete(order_number).then(response => {
					if (response.status) {
						this.setState(() => {
							this.removeSelectedRow();
							this.setLoader(false);
						});
						this.setServiceCharge();
						this.toastSuccess(response.data.message);
					} else {
						this.setLoader(false);
						toastError(response.message);
					}
				});
			}
		});
	}

	saveClicked(data) {
		this.setLoader(true);

		const max = typeof data[2] === 'string' ? +data[2].replace(/,/g, '') : data[2];
		const price = typeof data[3] === 'string' ? +data[3].replace(/,/g, '') : data[3];

		if (this.isFloat(max) || this.isFloat(price)) {
			toastError('Unable to update invalid input with decimal');
			this.setLoader(false);
			this.removeSelectedRow();
			return;
		}
		const payload = {
			max,
			price
		};

		ServiceChargeService.update(data[4], payload).then(response => {
			if (response.data?.status) {
				this.setState(() => {
					this.removeSelectedRow();
					this.setLoader(false);
				});
				this.setServiceCharge();
				this.toastSuccess(response.data.message);
			} else {
				this.setLoader(false);
				this.removeSelectedRow();
				toastError(response.message);
			}
		});
	}

	toastSuccess = msg => {
		Swal.fire({
			animation: false,
			title: 'Success',
			text: msg,
			icon: 'success',
			confirmButtonText: 'Okay',
			customClass: 'otp_message_success'
		});
	};

	getMuiTheme = () =>
		createMuiTheme({
			overrides: {
				MUIDataTableHeadCell: {
					root: {
						fontSize: '15px',
						fontWeight: 'bold',
						textAlign: 'center'
					},
					toolButton: {
						marginLeft: '10%',
						margin: '0 auto'
					},
					sortAction: {
						margin: '0 auto'
					}
				},
				MUIDataTableBodyCell: {
					root: {
						textAlign: 'center'
					}
				}
			}
		});

	componentDidMount() {
		this.setServiceCharge();
	}

	render() {
		const current_user_info = Session.get('CURRENT_USER_INFO');

		const { isSUPER_ADMIN } = VERIFY_AUTHORIZATION(current_user_info);
		const service_charge = [
			{
				name: 'id',
				label: 'id',
				options: {
					display: false,
					sort: false
				}
			},
			{
				name: 'min',
				label: 'Min (₱)',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<span className="bold-important">
								{value ? CommaSeparator(parseFloat(value).toFixed(2)) : ''}
							</span>
						);
					}
				}
			},

			{
				name: 'max',
				label: 'Max (₱)',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta, updateValue) => {
						return (
							<FormControlLabel
								control={
									<TextField
										disabled={this.state.selectedRow != tableMeta.rowData[0]}
										InputProps={{
											max: tableMeta.rowData[2],
											className: 'bold-important'
										}}
										required
										type="text"
										value={value ? CommaSeparator(value) : ''}
									/>
								}
								onChange={event => {
									const value = onChangeCommaSeperator(event.target.value);
									updateValue(value);
									this.updateMaxPrice(event.target.value, tableMeta.columnData.name);
								}}
							/>
						);
					}
				}
			},

			{
				name: 'price',
				label: 'Price (₱)',

				options: {
					sort: false,
					customBodyRender: (value, tableMeta, updateValue) => {
						return (
							<FormControlLabel
								control={
									<TextField
										disabled={this.state.selectedRow != tableMeta.rowData[0]}
										InputProps={{
											price: tableMeta.rowData[3],
											className: 'bold-important'
										}}
										required
										type="text"
										value={value ? CommaSeparator(value) : ''}
									/>
								}
								onChange={event => {
									const value = onChangeCommaSeperator(event.target.value);
									updateValue(value);
									this.updateMaxPrice(event.target.value, tableMeta.columnData.name);
								}}
							/>
						);
					}
				}
			},

			{
				name: 'order_number',
				label: 'Actions',
				options: {
					sort: false,
					customBodyRender: (_value, tableMeta, _updateValue) => {
						return (
							<>
								{!isSUPER_ADMIN ? (
									<Lock color="secondary" />
								) : this.state.selectedRow != tableMeta.rowData[0] ? (
									<>
										{tableMeta.rowIndex === 0 ||
										tableMeta.rowIndex === this.state.total - 1 ? null : (
											<DeleteIcon
												color="secondary"
												onClick={_event => {
													this.deleteClicked(tableMeta.rowData[4]);
												}}
												style={{ cursor: 'pointer' }}
											/>
										)}

										<EditIcon
											color="primary"
											onClick={_event => {
												this.editClicked(tableMeta.rowData[0]);
											}}
											style={{ cursor: 'pointer' }}
										/>
									</>
								) : (
									<>
										<SaveIcon
											onClick={_event => {
												this.saveClicked(tableMeta.rowData);
											}}
											// disabled={this.isFormValid()}
											style={{ color: green[500], cursor: 'pointer' }}
										/>
										<CancelIcon
											onClick={_event => {
												this.cancelEdit();
											}}
											style={{ color: orange[500], cursor: 'pointer' }}
										/>
									</>
								)}
							</>
						);
					}
				}
			}
		];
		const options = {
			serverSide: false,

			print: false,
			download: false,
			filter: false,
			responsive: 'scroll',
			selectableRows: 'none',
			textLabels: {
				body: {
					noMatch: this.state._isLoader ? (
						<Spin indicator={<LoadingOutlined />} size="large">
							{' '}
							Loading data please wait...
						</Spin>
					) : (
						'Sorry, no matching records found'
					)
				}
			},
			responsive: 'scroll',
			onSearchChange: searchText => {
				this.removeSelectedRow();
			}
		};

		return (
			<>
				<PageHeader text="Service Charge Fixed Price" />
				<MuiThemeProvider theme={this.getMuiTheme()}>
					<MUIDataTable
						columns={service_charge}
						data={this.state.tableData}
						options={options}
						theme={this.getMuiTheme()}
						title={<>{isSUPER_ADMIN && <AddForm setServiceCharge={this.setServiceCharge} />}</>}
					/>
				</MuiThemeProvider>
				{this.state._isLoading ? <Loader /> : null}
			</>
		);
	}
}

export default withRouter(ServiceCharge);
